import { Container } from "./styles";

export const TabSection = ({ label, active, onClick}) => {
  return (
    <Container className={active && "active"} onClick={onClick}>
      <p>{label}</p>
    </Container>
  );
};
